import { z } from 'zod'
import { isoDate } from '../reports/expenses-by-category/iso-date'

// income-expense-table widget query: optional ISO-date (YYYY-MM-DD) window. rejecting junk here means
// the service never receives an Invalid Date that reaches Prisma / the days divisor as a 500 (#296).
export const incomeExpenseTableQuerySchema = z.object({
  startDate: isoDate.optional(),
  endDate: isoDate.optional(),
})

export type IncomeExpenseTableQueryDto = z.infer<typeof incomeExpenseTableQuerySchema>
